export default {
  "logoLink": "https://www.atfx.com/es",//修改该参数请在/static/lang.js也需修改
  "FCA_License_No": "Licencia FCA",//修改该参数请在/static/lang.js也需修改
  "headTtitle": "Abra una cuenta bursátil real de Forex y CFD | ATFX UK",//修改该参数请在/static/lang.js也需修改
  "topFixedBanner": "Las apuestas por diferencias y los CFD son instrumentos complejos y conllevan un alto riesgo de perder dinero rápidamente debido al apalancamiento. La gran mayoría de las cuentas de clientes minoristas pierden dinero cuando operan con CFDs. Debe considerar si puede permitirse asumir el alto riesgo de perder su dinero.",//修改该参数请在/static/lang.js也需修改
  "topFixedBannerShort": "El 59.38% de las cuentas de inversores minoristas pierden dinero al comerciar CFDs con este proveedor.",//修改该参数请在/static/lang.js也需修改
  "headDescription": "Abra una cuenta ATFX de Forex y CFD con un bróker regulado por la FCA del RU. Spreads bajos, apalancamiento de 1:200, plataforma MT4, atención al cliente las 24/5 ¡Registre una cuenta ya!",
  "policyBarClose": 'La Firma ha tomado la decisión de dejar de brindar servicios a clientes minoristas, con efecto inmediato. Por lo tanto, no podemos aceptar ninguna solicitud.<br />Los servicios para clientes profesionales no se verán afectados. Para aplicaciones profesionales por favor contacte <a href="mailto:cs.uk@atfx.com">cs.uk@atfx.com</a>',
  "policyBar":'Utilizamos cookies para asegurarnos de que tienes la mejor experiencia en nuestro sitio web. Al seguir navegando, aceptas nuestro uso de cookies.<a title="[Leer más]" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blanck">[Leer más]</a>',
  "policyBarButton":'Aceptar',
  "header": {
    "registration": "Apertura de cuenta",
    "personalDetails1": "Información personal 1",
    "personalDetails2": "Información personal 2",
    "financialDetails": "Información financiera",
    "Experience": "Experiencia",
    "Knowledge": "Conocimiento",
    "Acknowledgements": "Reconocimientos",
    "previewPage":"Vista previa",
    "liveTrading": "Opera en vivo"
  },
  footer:{//修改该参数请在/static/lang.js也需修改
    "copyright":"© 2020 ATFX.COM. Todos los derechos reservados.",
    "terms1":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf" target="_blank" rel="noopener"> Política de privacidad</a>',
    "terms2":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blank" rel="noopener">Política de cookies</a>',
    "terms3":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target="_blank" rel="noopener">Términos y Condiciones</a>',
    "Legal": 'ABRA UNA CUENTA LIVE Información jurídica: AT Global Markets (UK) Limited está autorizada y regulada por la Autoridad de Conducta Financiera (FCA) en el Reino Unido. Número de registro en la FCA (760555). Domicilio social: 1st Floor, 32 Cornhill, London EC3V 3SG, United Kingdom. N.º de empresa 09827091',
    "riskWaring":'Los CFD son instrumentos complejos y tienen un alto riesgo de perder dinero rápidamente debido al apalancamiento. <strong>El 59.38% de las cuentas de inversionistas minoristas pierden dinero cuando negocian CFD con este proveedor. </strong>Debe considerar si entiende cómo funcionan los CFD´s y si puede permitirse asumir el alto riesgo de perder su dinero. Productos complejos. La CNMV considera que, en general, no son indicados para pequeños inversores. Lee el aviso de descargo de responsabilidad completo en las páginas 42-45 de nuestro documento <a title="Términos y condiciones" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target="_blanck">Términos y condiciones</a> de negocio. <p>La comercialización de servicios y la adquisición de clientes solo puede llevarse a cabo en España por una entidad autorizada o por medio de un agente vinculado.</p>',
    "otherInfo":"La información contenida en este sitio web no se dirige a residentes de los Estados Unidos, Bélgica o cualquier país particular fuera del Reino Unido, ni está destinada a ser distribuida ni utilizada por ninguna persona en ningún país o jurisdicción donde tal distribución o uso sea contrario a la ley o normativa local."
  },
  "headerMsg": {
    "personalDetails1":"Al enviar esta información confirmo que acepto los términos empresariales estándar de <a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>ATFX</a> y de <a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>la política de privacidad</a> y podrían ponerse en contacto conmigo sobre mi solicitud.",
    "personalDetails2":"Al enviar esta información confirmo que acepto los términos empresariales estándar de <a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>ATFX</a> y de <a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>la política de privacidad</a> y podrían ponerse en contacto conmigo sobre mi solicitud.",
    "financialDetails": "Como empresa regulada por la FCA estamos obligados a evaluar si nuestros productos son apropiados para usted. La respuesta que nos proporcione determinará si podemos ofrecerte nuestros servicios.",
    "experience": "Como empresa regulada por la FCA estamos obligados a evaluar si nuestros productos son apropiados para usted. La respuesta que nos proporcione determinará si podemos ofrecerte nuestros servicios.",
    "knowledge": "Como empresa regulada por la FCA estamos obligados a evaluar si nuestros productos son apropiados para usted. La respuesta que nos proporcione determinará si podemos ofrecerte nuestros servicios.",
    "acknowledgements": "Al completar esta solicitud, usted confirma que entiende que FX con margen y los CFD son productos apalancados y suponen un alto riesgo para su capital invertido. Además, confirma que es su responsabilidad supervisar su cuenta y la naturaleza de los productos, lo que significa que podría perder más de su inversión inicial."
  },
  "changeLanguage": "Cambiar idioma",
  "back": "Volver",
  "next": "Siguiente",
  "finish": "Finalizar",
  "personalDetails1": {
    "estimatedTime":"Tiempo estimado para completar tu registro es de  5 min",
    "Gender": "Género",
    "genderSelect": {
      "M": "Sr.",
      "F": "Sra.",
      "O":"Otro"
    },
    "OtherGender":"Otro Género",
    "Title": "Titulo",
    "titleSelect":{
      "Mr":"Señor",
      "Mrs":"Señora",
      "Miss":"Señorita",
      "Dr":"Dr",
      "Other":"Otro"
    },
    "OtherTitle":"Otro título",
    "First_Name": "Nombre",
    "Surname": "Apellidos",
    "Email": "Correo electrónico",
    "Email_Confirm": "Confirmar correo electrónico",
    "Lang": "Idioma del correo electrónico",
    "emailLanguages": {
      "ENG": "Inglés",
      "CHT": "Chino tradicional",
      "CHS": "Chino simplificado",
      "ARA": "Árabe",
      "ESP": "Español",
      "ITA": "italiano",
      "GER": "German",
      "PTG": "Portugués"
    },
    "MT4_Currency":"Moneda de la cuenta comercial",
    "MT4CurrencySelect":{
      "USD":"(USD) Dólar",
      "GBP":"(GBP) Libras",
      "EUR":"(EUR) Euros"
    },
    "Account_Type": "Tipo de cuenta MT4",
    "Account_TypeSelect": {
      "CFDs": "CFDs",
      "SpreadBetting": "Spread betting"
    },
    "Country": "País de residencia",
    "countrySelect": {
      "USA": "United States of America",
      "HKG": "Hong Kong",
      "GBR": "Reino Unido",
      "CHN": "China",
      "TWN": "Taiwán",
      "ARE": "Emiratos Árabes Unidos",
      "ALB": "Albania",
      "AND": "Andorra",
      "AIA": "Anguila",
      "ATG": "Antigua y Barbuda",
      "ARG": "Argentina",
      "ARM": "Armenia",
      "ABW": "Aruba",
      "AUS": "Australia",
      "AUT": "Austria",
      "AZE": "Azerbaiyán",
      "BHS": "Bahamas",
      "BHR": "Bahrein",
      "BGD": "Bangladesh",
      "BRB": "Barbados",
      "BLR": "Bielorrusia",
      "BEL": "Bélgica",
      "BLZ": "Belice",
      "BEN": "Benin",
      "BMU": "Bermuda",
      "BOL": "Bolivia",
      "BWA": "Botswana",
      "BVT": "Isla Bouvet",
      "BRA": "Brasil",
      "BRN": "Brunei",
      "BGR": "Bulgaria",
      "BFA": "Burkina Faso",
      "BDI": "Burundi",
      "KHM": "Camboya",
      "CMR": "Camerún",
      "CPV": "Cabo verde",
      "CYM": "Islas Caimán",
      "CAF": "República Central Africana",
      "TCD": "Chad",
      "CHL": "Chile",
      "CCK": "Islas Cocos",
      "COL": "Colombia",
      "COM": "Comoras",
      "COK": "Islas Cook",
      "CRI": "Costa Rica",
      "CIV": "Costa de Marfil",
      "HRV": "Croacia",
      "CUB": "Cuba",
      "CYP": "Chipre",
      "CZE": "Checoslovaquia",
      "DNK": "Dinamarca",
      "DJI": "Yibuti",
      "DMA": "Dominica",
      "DOM": "República Dominicana",
      "EGY": "Egipto",
      "SLV": "El Salvador",
      "ERI": "Eritrea",
      "EST": "Estonia",
      "ESP": "España",
      "ETH": "Etiopia",
      "FJI": "Fiji",
      "FIN": "Finlandia",
      "PYF": "Polinesia francesa",
      "GAB": "Gabón",
      "GEO": "Georgia",
      "DEU": "Alemania",
      "GHA": "Ghana",
      "GIB": "Gibraltar",
      "GRC": "Grecia",
      "GRL": "Groenlandia",
      "GRD": "Granada",
      "GLP": "Guadalupe",
      "GTM": "Guatemala",
      "GIN": "Guinea",
      "GNB": "Guinea-Bissau",
      "HTI": "Haití",
      "HMD": "Islas Heard and McDonald",
      "HND": "Honduras",
      "HUN": "Hungría",
      "ISL": "Islandia",
      "IND": "India",
      "IDN": "Indonesia",
      "IRL": "Irlanda",
      "ISR": "Israel",
      "ITA": "Italia",
      "JAM": "Jamaica",
      "JPN": "Japón",
      "JOR": "Jordania",
      "KAZ": "Kazajstán",
      "KEN": "Kenia",
      "KIR": "Kiribati",
      "KOR": "Korea del sur",
      "KWT": "Kuwait",
      "KGZ": "Kirguizistán",
      "LVA": "Latvia",
      "LSO": "Lesoto",
      "LBR": "Liberia",
      "LBY": "Libia",
      "LIE": "Liechtenstein",
      "LTU": "Lituania",
      "LUX": "Luxemburgo",
      "MAC": "Macao",
      "MDG": "Madagascar",
      "MWI": "Malaui",
      "MYS": "Malasia",
      "MDV": "Maldivas",
      "MLI": "Mali",
      "MLT": "Malta",
      "MHL": "Islas Marshall",
      "MTQ": "Martinica",
      "MUS": "Mauricios",
      "MYT": "Mayotte",
      "MEX": "México",
      "MDA": "Moldavia",
      "MCO": "Mónaco",
      "MNG": "Mongolia",
      "MNE": "Montenegro",
      "MSR": "Montserrat",
      "MAR": "Marruecos",
      "MOZ": "Mozambique",
      "NAM": "Namibia",
      "NRU": "Nauru",
      "NLD": "Paises Bajos",
      "NCL": "Nueva Caledoinia",
      "NZL": "Nueva Zelanda",
      "NIC": "Nicaragua",
      "NER": "Nigeria",
      "NGA": "Nigeria",
      "NIU": "Niue",
      "NFK": "Isla Norfolk",
      "NOR": "Noruega",
      "OMN": "Omán",
      "PAK": "Pakistán",
      "PSE": "Palestina",
      "PRY": "Paraguay",
      "PER": "Perú",
      "PHL": "Filipinas",
      "PCN": "Pitcairn",
      "POL": "Polonia",
      "PRT": "Portugal",
      "QAT": "Qatár",
      "ROU": "Rumania",
      "RUS": "Rusia",
      "RWA": "Ruanda",
      "SHN": "Santa Helena",
      "KNA": "San Cristóbal y Nieves",
      "LCA": "Santa Lucía",
      "SPM": "San Pedro y Michelon",
      "VCT": "San Vicente y las Granadinas",
      "WSM": "Samoa",
      "SMR": "San Marino",
      "STP": "Santo Tomé y Príncipe",
      "SAU": "Arabia Saudí",
      "SEN": "Senegal",
      "SRB": "Serbia",
      "SYC": "Seychelles",
      "SLE": "Sierra Leona",
      "SGP": "Singapur",
      "SVK": "Eslovaquia",
      "SVN": "Eslovenia",
      "ZAF": "Sudáfrica",
      "SUR": "Surinam",
      "SJM": "Islas de Svalbard y Jan Mayen",
      "SWZ": "Suazilandia",
      "SWE": "Suecia",
      "CHE": "Suiza",
      "TJK": "Taikistán",
      "TZA": "Tanzania",
      "THA": "Tailandia",
      "TLS": "Timor-Leste",
      "TGO": "Togo",
      "TON": "Tonga",
      "TTO": "Trinidad y Tobago",
      "TUN": "Túnez",
      "TUR": "Turquía",
      "TKM": "Turkmenistán",
      "TCA": "Islas Turcas y Caicos",
      "TUV": "Tuvalu",
      "UKR": "Ucrania",
      "URY": "Uruguay",
      "UZB": "Uzbekistán",
      "VUT": "Vanuatu",
      "VAT": "Vaticano",
      "VEN": "Venezuela",
      "VNM": "Vietnam",
      "WLF": "Wallis y Futuna",
      "ESH": "Sahara occidental",
      "ZMB": "Zambia",
      "DZA": "Algeria",
      "AGO": "Angola",
      "BIH": "Bosnia",
      "GMB": "Gambia",
      "GUY": "Guyana",
      "IRQ": "Iraq",
      "RKS": "Kosovo",
      "LBN": "Libano",
      "MKD": "Macedonia",
      "NPL": "Nepal",
      "PAN": "Panama",
      "PNG": "Papau Nueva Guinea",
      "LKA": "Sri Lanka"
    }
  },
  "personalDetails2": {
    "Addr": "Dirección - Línea 1",
    "Addr2": "Dirección - Línea 2",
    "City": "Municipio",
    "Postcode": "Código postal",
    "Building_Name": "Número / nombre del edificio",
    "Street": "Calle",
    "Province": "Provincia",
    "birthDate": "Fecha de nacimiento",
    "birthYear": "Año",
    "birthMonth": "Mes",
    "birthSecond": "Día",
    "Nationality": "Nacionalidad",
    "isHavePass": "¿Tiene pasaporte?",
    "PotSelect": {
      "havePot": "Sí",
      "noPot": "No"
    },
    "NAT_ID": "Número de Pasaporte",
    "Phone": "Teléfono",
    "countryPlace": "País de residencia fiscal",
    "TIN": "NIF (Número de identificación fiscal)",
    "Doc_Type": "Tipo de documento de identidad",
    "idTypeSelect": {
      "POT": "Pasaporte",
      "IDC": "Documento nacional de identidad",
      "DRI": "Permiso de conducir"
    },
    "Doc_No": "Número de documento de identidad",
    "bankCardType": "Tipo de tarjeta bancaria",
    "bankCardTypeSelect": {
      "DR": "Tarjeta de débito",
      "CR": "Tarjeta de crédito"
    },
    "Addr_Country":"Dirección País",
    "Bank_Card_No": "Número de banco",
    "bankCardNoConfirm": "Confirmación del número de banco",
    "Bank": "Banco",
    "bankSelect": {
      "ICBK": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA",
      "ABOC": "AGRICULTURAL BANK OF CHINA",
      "PCBC": "CHINA CONSTRUCTION BANK CORPORATION",
      "BKCH": "BANK OF CHINA LIMITED",
      "CMBC": "CHINA MERCHANTS BANK",
      "COMM": "BANK OF COMMUNICATIONS",
      "MSBC": "CHINA MINSHENG BANKING CORPORATION, LIMITED",
      "EVER": "CHINA EVERBRIGHT BANK",
      "SPDB": "SHANGHAI PUDONG DEVELOPMENT BANK",
      "FJIB": "INDUSTRIAL BANK",
      "CIBK": "CITIC BANK CORPORATION LIMITED",
      "PSBC": "POSTAL SAVINGS BANK OF CHINA",
      "SZCB": "SHENZHEN DEVELOPMENT BANK CO., LTD",
      "GDBK": "CHINA GUANGFA BANK",
      "BOSH": "BANK OF SHANGHAI",
      "BJCN": "BANK OF BEIJING",
      "HXBK": "HUA XIA BANK",
      "other": "OTRO"
    },
    "OtherBank": "Otros bancos",
    "Beneficiary_Name": "Por favor, utilice el mismo nombre de la cuenta en su banco, no se permiten operaciones con terceros",
    "SWIFT_Code": "Código Swift bancario",
    "Branch_Name": "Nombre de la sucursal",
    "Bank_Addr": "Dirección de la sucursal",
    "Branch_Province": "Provincia de la sucursal",
    "Branch_City": "Ciudad de la sucursal",
    "bankCardImg": "Imagen de la tarjeta bancaria",
    "IBAN_Code":"Codificación IBAN",
    "docFrontImgword": "Imagen documento de identidad (parte frontal)",
    "docBackImgword": "Imagen documento de identidad (parte trasera)",
    "addressUpload": "Prueba de residencia 1",
    "addressUpload2": "Prueba de residencia 2",
    "addressUploadTxt1": "Pruebas disponibles: lista de facturas de electricidad /gas con menos de tres meses de antiguedad / extractos bancarios / permisos de residencia / licencias / documento de identidad / Hukou (si el solicitante no es el cabeza de familia, será necesario intorducirlo en las imágenes de la página nº1);",
    "addressUploadTxt2": "la prueba de residencia no debe ser la misma a la del certificado de identidad.",
    "docImgword1": "documento adjunto 1",
    "docImgword2": "documento adjunto 2",
    "docImgword3": "documento adjunto 3",
    "docImgword4": "documento adjunto 4",
    "docImgword5": "documento adjunto 5",
    "fileUpload": {
      "imgtUpload": "cargar",
      "uploadFileArr": [{
        "labelTxt": "Imagen documento de identidad 1",
        "ValidateNull": "Por favor, seleccione",
        "sizeLimit": "¡La imagen del documento de identidad 1 no puede exceder los 5MB!"
      }, {
        "labelTxt": "Imagen del documento de identidad 2",
        "ValidateNull": "Por favor, seleccione",
        "sizeLimit": "¡La imagen del documento de identidad 2 no puede exceder los 5MB!"
      }, {
        "labelTxt": "Prueba de residencia",
        "ValidateNull": "Por favor, seleccione",
        "sizeLimit": "La imagen de la prueba de residencia no puede exceder los 5MB."
      }, {
        "labelTxt": "Prueba de residencia 2",
        "ValidateNull": "Por favor, seleccione",
        "sizeLimit": "La imagen de la prueba de residencia no puede exceder los 5MB."
      },{
        "labelTxt": "Otros archivos",
        "ValidateNull": "Por favor, seleccione",
        "sizeLimit": "¡Otros archivos no pueden exceder los 5MB!"
      }],
      "addressUploadHtml": {
        "upload_your_documents":"Sube tus documentos de identidad",
        "documents_not_ready":"La documentación no esta lista?",
        "noe": "*Los solicitantes deben proporcionar una foto de identificación y una prueba de dirección para verificar su identidad. No aceptamos: facturas de teléfonos móviles, facturas de tarjetas de crédito o facturas de servicios móviles; recibos de seguros; factura por bienes/servicios comprados.",
        "noe2": "Todavía puede completar su solicitud si no tiene los documentos requeridos en este momento.<br/><b>Sin embargo, no podrá comerciar hasta que recibamos los documentos requeridos.<b/>",
        "header1": "Prueba de identidad (Documentación mínima requerida $Logic)",
        "list1": "Requerimos copias en color del documento original de DNI/Pasaporte emitido por el gobierno. Para la identificación requerimos lados delanteros y traseros de la tarjeta de Identificación.",
        "list1_new":"Se requiere una copia del pasaporte original clara y a color con todas las partes visibles",
        "header2": "Prueba de dirección ( Documentación mínima requerida $Logic)",
        "list2": "<ol class='list-style-position:inside'><li>Factura de servicios públicos (agua/electricidad/gas) - emitida en los últimos 3 meses,</li><li>Extracto bancario emitido en los últimos 3 meses.</li><li>Aceptamos libros de residencia /libros de propiedad incluyendo el Hukou chino - pero están sujetos a revisión.</li><li>Debe proporcionarse un contrato de alquiler actual y una factura de servicios públicos del mismo (agua/gas/electricidad) pagado en los 3 meses anteriores.</li><li> Una factura fiscal reciente, si se ha emitido únicamente en los últimos 6 meses.</li><li> Una factura de teléfono fijo emitida en los últimos 3 meses.</li></ol>",
        "strongTxt": "<strong>Como parte de nuestros requisitos reglamentarios, podríamos requerir documentación adicional de acuerdo a su aplicación.</strong>",
        "sizeLimit":" El tamaño del archivo no puede exceder 5MB",
      }
    },
    "isHaveCitizen": "¿Eres ciudadano de los Estados Unidos de América?",
    "CitizenSelect": {
      "Y": "Sí",
      "N": "No"
    },
    "citizen_Tip":"Desafortunadamente, no podemos abrir cuentas de trading  para ciudadanos Estadounidenses.",
    "isDualCitizenship": "¿Estás pagando impuestos en algun pais distinto a tu pais de residencia?",
    "DualCitizenshipSelect": {
      "Y": "Sí",
      "N": "No"
    },
    "Dual_Nationality":"Pais",
    "IS_Politically_Person": "¿Es usted una persona políticamente expuesta?",
    "IS_Politically_Exposed":'"Una persona políticamente expuesta significa una persona natural que está o se le ha confiado funciones públicas importantes en la república o en otro país,un familiar inmediatamente cercado a tal persona, así como una persona que se sabe está estrechamente asociada a esta persona: <br/>Dicho esto, por el propósito de la presente definición, “una función pública importante” significa cualquiera de las siguientes funciones públicas:<br/>(a) cabeza del estado, cabeza del gobierno, ministros y viceministros o ministros ayudantes; <br/>(b) miembros del parlamento o de cuerpos legislativos similares; <br/>(c) miembros de entidades gobernantes de partidos políticos; <br/>(d) miembros del tribunal supremo, del tribunal constitucional u otros cuerpos judiciales de alto nivel,cuyas decisiones no se pueden apelar, excepto en circunstancias excepcionales: <br/>(e) miembros de tribunales y de auditores o del consejo de los bancos centrales. <br/>(f) embajadores, asuntos exteriores y personas de alta categoría en las fuerzas armadas;<br/>(g) miembros de cuerpos administrativos, o entidades supervisoras o directivas de empresas estatales; <br/>(h) directores, vicedirectores y miembros de un consejo o con una función equivalente a una organización internacional; <br/>(i) alcalde: con funciones públicas proporcionadas no más allá de lo referido en los puntos (a) al <br/>(i) será entendido como categoría media o para directivos en sus inicios; <br/>Más allá de la “familia cercana de la persona expuesta políticamente” también se incluyen los siguientes: <br/>(a) el cónyuge o la persona que se considere el equivalente al cónyuge de una persona políticamente expuesta; <br/>(b) los hijos y sus cónyuges, o personas consideradas el equivalente a su s cónyuges de una persona políticamente expuesta; <br/>(c) los padres de una persona políticamente expuesta. <br/>Proporcionado más allá que la “persona que se conoce estar estrechamente asociada a la persona expuesta políticamente” significa una persona natural: <br/>(a) de la que se conoce poseer una propiedad conjunta beneficiosa de entidades u organizaciones legales,o cualquier otra relación cercana empresarial, con una persona expuesta políticamente; <br/>(b) que posee la exclusiva propiedad beneficiosa de una entidad u organización legales que se sabe ha sido establecida para el beneficio de facto de la persona expuesta políticamente.',
    "IS_Politically_Person_Select": {
      "Y": "Yes",
      "N": "No"
    },
  },
  "financialDetails": {
    "Emp_Status": "Estado laboral",
    "employmentStatusSelect": {
      "b": "Empleado",
      "a": "Autónomo",
      "c": "Estudiante",
      "e": "Jubilado",
      "d": "Desempleado"
    },
    "Freelance_OwnACompany": "Freelance / Propietario de su propia compañía",
    "Freelance_OwnACompany_select": {
      "0": "Freelance",
      "1": "Propietario de su propia compañía"
    },
    "Position": "Cargo Profesional",
    "FD_Position_select": {
      "0": "Directo Ejecutivo (Director ejecutivo, director de operaciones, director financiero)",
      "1": "Alto ejecutivo",
      "2": "General / Director medio",
      "3": "Supervisor",
      "4": "Empleado",
      "5": "Personal",
      "6": "Pasantía / Práctica",
      "7": "Otros (por favor, especificar)"
    },
    "Employer": "Nombre de la empresa",
    "Biz_Nature": "Naturaleza del negocio",
    "financialRegulator": "¿Está su jefe autorizado por la FCA u otro regulador financiero?",
    "financialRegulatorSelect": {
      "Y": "Sí",
      "N": "No"
    },
    "Industry_Sector": "Industria / Sector",
    "Industry_Sector_select": {
      "0": "Contabilidad",
      "1": "Publicidad / Medios de comunicación",
      "2": "Informática / Internet / Comunicación / Electrónica",
      "3": "Educación / Formación",
      "4": "Energía / Materiales brutos",
      "5": "Servicios financieros (Finanzas / Banking / Seguros)",
      "6": "Gobierno /ONG",
      "7": "Recursos humanos",
      "8": "Legal",
      "9": "Marketing",
      "10": "Logística / Transporte",
      "11": "Farmacéutica / Médica",
      "12": "Servicios profesionales",
      "13": "Sector inmobiliario / Construcción",
      "14": "Industria de servicios",
      "15": "Comercio / Consumidor / Manufacturación / Operaciones",
      "16": "Otros (por favor, especificar)"
    },
    "Annual_Income": "Ingresos anuales",
    "Annual_Income_word":"Esto incluye todos los ingresos ganados incluyendo salarios, pensiones, intereses, dividendos, ingresos por alquiler, etc.",
    "Total_Saving_Investments": "Ahorros e inversiones totales",
    "Total_Saving_word": "Esto incluye todas las cuentas bancarias y en brókeres, certificados, bonos, inversiones de capital en el mercado, etc.",
    "Total_Saving_Investments_select": {
      "0": "Más de US$500,000",
      "1": "US$200,000-US$499,999",
      "2": "US$100,000-US$199,999",
      "3": "US$50,000-US$99,999",
      "4": "US$25,000-US$49,999",
      "5": "US$10,000-US$24,999",
      "6": "US$2,000-US$9,999",
      "7": "Menos de US$2,000"
    },
    "liquidNetWorth": "Patrimonio líquido (excluyendo la residencia privada)",
    "financialPortfolio": "Valor de su cartera financiera",
    "annualIncomeSelect": {
      "0": "Más de US$200,000",
      "1": "US$100,000-US$199,999",
      "2": "US$50,000-US$99,999",
      "3": "US$25,000-US$49,999",
      "4": "US$10,000-US$24,999",
      "5": "Menos de US$10,000"
    },
    "fundsSource": "Fuente de esos fondos",
    "fundsSourceSelect": {
      "0": "Ninguna",
      "1": "Familia e ingresos de mi pareja",
      "2": "Beneficios gubernamentales",
      "3": "Préstamo / Crédito",
      "4": "Pensión",
      "5": "Ingresos por propiedades",
      "6": "Otros (por favor, especificar)"
    },
    "Funds_Source": "Otra fuente de ingresos",
    "Intend_Deposit": "¿Cuánto tiene pensado depositar?",
    "intendDepositSelect": {
      "0": "Más de US$100,000",
      "1": "US$80,000 – US$99,999",
      "2": "US$50,000 – US$79,999",
      "3": "US$25,000 – US$49,999",
      "4": "US$10,000 – US$24,999",
      "5": "Menos de US$10,000"
    },
    "Other_Industry_Sector": "Otra industria / sector",
    "Other_Position": "Otro Cargo Profesional",
    "Other_Biz_Nature": "Otra naturaleza de negocios",
    "Other_Funds_Source": "Otras fuentes de ingresos",
    "Afford_To_Lose_Error":"Los CFD son productos de alto riesgo, y solo debería operar con capital que pueda permitirse perder.",
    "Afford_To_Lose":"¿Puede permitirse perder los fondos que ha planeado invertir?",
    "Afford_To_Lose_Select": {
      "Y": "Sí",
      "N": "No"
    },
    "Open_Trading_Account":"¿Por qué desea abrir una cuenta bursátil con ATFX?",
    "Open_Trading_Account_Select": {
      "0": "Para realizar una especulación a medio-corto plazo en los mercados financieros",
      "1": "Para realizar exposiciones frente a coberturas a corto-medio plazo en inversiones existentes",
      "2": "Especulación a corto y medio plazo en mercados financieros y cobertura frente a la exposición en inversiones existentes."
    },
    "ATFX_Client_Pro":"ATFX ha destinado sus productos para que sean adecuados solo para clientes con los objetivos anteriores, por favor, no continúe con esta solicitud si sus objetivos difieren de los enumerados anteriormente.",
    "Annual_Income_Total":"Por favor, proporcione sus ingresos anuales actuales",
    "Saving_Investments_Money":"Por favor, proporcione sus inversiones y ahorros actuales totales",
  },
  "Experience": {
    "experienceLabel": "En los ultimos tres años, ¿Hasta que punto ha intercambiado los siguientes instrumentos financieros en los que ha tomado sus propias decisiones comerciales?",
    "Futures_Options": "Futuros / Opciones",
    "Futures_Options_select": {
      "0": "En más de 40 ocasiones",
      "1": "De 15 a 40 ocasiones",
      "2": "De 1 a 15 ocasiones",
      "3": "Nunca"
    },
    "CFDs_Spread_Bets": "CFD, Derivados de cambio extranjero o spread bets",
    "CFDs_Spread_Bets_select": {
      "0": "En más de 40 ocasiones",
      "1": "De 15 a 40 ocasiones",
      "2": "De 1 a 15 ocasiones",
      "3": "Nunca"
    },
    "Derivative_Trade_over2": "En los últimos doce meses, ¿Ha llevado a cabo al menos dos operaciones por trimestre en FX / CFD / Opciones al contado / Futuros o Spread bets, donde haya tomado sus propias decisiones?",
    "Derivative_Trade_over2_select": {
      "b": "Sí",
      "a": "No"
    },
    "Derivative_Trade_over40": "En los últimos tres años, ¿Ha realizado cuarenta operaciones en un periodo de doce meses en FX / CFD / Opciones al contado / Futuros o Spread bets?",
    "Derivative_Trade_over40_select": {
      "b": "Sí",
      "a": "No"
    },
    "Average_Annual_Investment":"¿Cuál es el volumen medio anual de sus cantidades invertidas durante sus transacciones anteriores en los productos financieros que ha seleccionado previamente?",
    "Average_Annual_Investment_select": {
      "0": "Nunca he invertido",
      "1": "Menos de $500 ",
      "2": "Entre $500 hasta $2,500",
      "3": "Entre $2,500 hasta $10,000",
      "4": "Más de $10,000"
    },
    "Average_Leverage_Level":"¿Cuál es el nivel de apalancamiento medio que ha utilizado para operar en los productos financieros que ha seleccionado anteriormente?",
    "Average_Leverage_Level_select": {
      "0": "Nunca he utilizado el apalancamiento",
      "1": "Hasta un 1:10",
      "2": "Entre 1:10 - 1:25",
      "3": "Entre 1:25 - 1:50",
      "4": "Entre 1:50 - 1:100",
      "5": "Más de 1:100"
    }
  },
  "Knowledge": {
    "DT_Work_Experience": "¿Has trabajado alguna vez en alguna posición la cual requiera el conocimiento de productos apalancados?",
    "DT_Work_Experience_select": {
      "txt1": "Sí",
      "txt2": "No",
      "subTxt1": "Tengo al menos 3 años de experiencia",
      "subTxt2": "Poseo menos de 3 años de experiencia o al menos un año de experiencia invirtiendo en mi propio nombre. "
    },
    "DT_Qualification": "¿ Tienes alguna cualificación la cual te haya dado la comprensión de entender acerca del comercio de productos apalancados?",
    "DT_Qualification_select": {
      "txt1": "Sí",
      "txt2": "No",
      "subTxt1": "Poseo una cualificación profesional o grado universitario como CFA, MBA, BSC o MA",
      "subTxt2": "Poseo una cualificación profesional o grado en finanzas, económicas, contabilidad o un campo similar"
    },
    "K_Sell_Position": "Si vendes 1 lote de Oro (XAUUSD) al precio de 1200 y el mercado se mueve al precio de 1300, ¿Ganarías o perderías dinero?",
    "K_Sell_Position_b": "Si vendes 1 lote de XAUUSD.SB de oro a un precio de 1200 y el mercado se mueve a un precio de 1300, ¿ganarías o perderías dinero?",
    "K_Sell_Position_select": {
      "0": "Perderé",
      "1": "Ganaré"
    },
    "Closing_Order": "Con el fin de prevenir que tu cuenta pierda mas que tu cantidad predeterminada, ¿ Limitarías tu pérdida colocando un Stop loss o Take profit?",
    "Closing_Order_select": {
      "0": "Stop Loss",
      "1": "Retirada de beneficio"
    },
    "K_Profit_Change": "¿ Entiende que cuanto mayor sea el apalancamiento, se incrementará tambien el riesgo en su capital cuando usted comercie con productos CFDs apalancados?",
    "K_Profit_Change_b": "¿entiende usted que cuanto mayor sea el apalancamiento, se incrementará el riesgo para su capital cuando negocie con productos FX y CFDs apalancados?",
    "K_Profit_Change_select": {
      "0": "Entendido",
      "1": "No entendido"
    },
    "K_Margin": "Cual sería el margen requerido para 1 lote (100.000) USD/JPY, si tu margen es 1:20?",
    "K_Margin_select": {
      "0": "USD 5,000",
      "1": "USD 50,000",
      "2": "USD 100,000"
    }
  },
  "Acknowledgements": {
    "A1": "Confirmo que la información que les he proporcionado es precisa y completa, y me comprometo a notificarles si hubiera algún cambio en dicha información",
    "A2": "He leído, entendido y acepto vincularme al Acuerdo del Cliente de AT Global Markets que se me ha proporcionado",
    "A2_txt": "El Acuerdo del Cliente de AT Global Markets",
    "A2_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>el Acuerdo del Cliente de AT Global Markets</a>",
    "A3": "He leído, entendido y acepto vincularme a la declaración de riesgo de  AT Global Markets que se me ha proporcionado.",
    "A3_txt": "La declaración de riesgo de AT Global Markets",
    "A3_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>la declaración de riesgos de AT Global Markets</a>",
    "A4": "He leído, entendido y acepto vincularme a la Política de ejecución de órdenes y a la Política de conflictos de AT Global Markets que se me ha proporcionado.",
    "A4_txt": "La Política de ejecución de órdenes y Política de conflictos de AT Global Markets",
    "A4_link": "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>la Política de órdenes de ejecución de AT Global Markets</a>y <a href='https://www.atfx.com/uk/wp-content/uploads/conflict-of-interests-policy-uk-en.pdf' target='_blank'>Política de conflictos</a>",
    "header": "Al completar esta solicitud, usted confirma que entiende que FX y CFD marginados son productos apalancados y conllevan un alto riesgo para su capital invertido. Además, confirma que es su responsabilidad vigilar su cuenta, y que la naturaleza de estos productos  puede dar como resultado una pérdida mayor a su inversión inicial.",
    "age": "Confirma que es mayor de 18 años.",
    "message": "La información proporcionada en esta solicitud es verdadera y correcta, y se compromete a notificarnos en caso de darse algún cambio en dicha información;",
    "receive": {
      "text": "Ha leído, entendido y acepta nuestros",
      "list": [
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf' target='_blank'>Términos de negocio y advertencia de riesgo</a>",
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>Política de órdenes de ejecución</a>",
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>Política de privacidad</a>",
        // "<a href='https://www.atfx.com/uk/wp-content/uploads/introducing-broker-disclosure-en.pdf' target='_blank'>Divulgación del bróker de introducción</a>",
        "<a href='https://www.atfx.com/es/condiciones-legales' target='_blank'>Documento de información clave</a>"
      ]
    },
    "A_select": {
      "text": "He leído, entiendo y acepto todos los términos",
      "Y": "He leído, entiendo y acepto todos los términos"
    },
    "checkboxTxt_A1": "He leído, entiendo y acepto todos los términos",
    "checkboxTxt_A2": "Entiendo que los CFD son productos apalancados y su rendimiento puede ser muy volátil",
    "checkboxTxt_A3": "Entiendo que es mi responsabilidad vigilar y gestionar mi cuenta",
    "checkboxTxt_A4": "Entiendo que cuando se opera con productos apalancados es posible perder más de la inversión inicial",
    "Marketing_Email_Preference": "Acepto recibir información de ATFX que puede contener materiales de marketing",
    "Marketing_automatically": "Entiendo que puedo optar por no recibir comunicaciones de marketing inmediatamente poniéndome en contacto con el equipo de <a href='https://www.atfx.com/es/sobre-nosotros/contacto' target='_blank'>servicio al cliente</a>.",
    "Marketing_Email_Preference_select":{
      "Y":"Sí",
      "N":"No"
    },
    "Hear_ATFX":"¿Cómo se enteró de ATFX?",
    "OtherHearATFX":"Otras maneras",
    "hearATFXSelect":{
      "Recommendation":"Recomendación",
      "SearchEngine":"Buscador",
      "MediaAdvertising":"Publicidad en medios",
      "Partnership":"Asociación",
      "Other":"Otro"
    },
    "Parent_IB_Code": "Código del remitente",
    "Rec_Type": "Tipo de remitente",
    "recTypeSelect": {
      "AA1": "AA1",
      "AA2": "AA2",
      "AA3": "AA3",
      "A01": "A01",
      "A02": "A02",
      "A03": "A03",
      "A00": "A00",
      "NAN": "Sin remitente"
    },
    "recGroup": "Grupo de remitente",
    "recGroupSelect": {
      "A": "A",
      "AA": "AA"
    }
  },
  "customErrMsg": {
    "fieldIsRequired": {
      "Gender": "Por favor, seleccione",
      "OtherGender":"Por favor ingrese Otro Género",
      "Title": "Por favor, seleccione",
      "OtherTitle":"Por favor ingrese otro título",
      "First_Name": "Nombre",
      "Surname": "Apellidos",
      "Email": "Dirección de correo electrónico",
      "Email_Confirm": "Confirmar correo electrónico",
      "Lang": "Por favor, seleccione",
      "Country": "Por favor, seleccione",
      "MT4_Currency":"Por favor, seleccione",
      "Account_Type":"Por favor, seleccione",
      "Addr": "Dirección",
      "Addr2": "Dirección - Línea 2",
      "City": "Ciudad",
      "Postcode": "Código postal",
      "Building_Name": "Número / nombre del edificio",
      "Street": "Calle",
      "Province": "Provincia",
      "Birth_Date_Year": "Fecha de nacimiento",
      "Birth_Date_Month": "Fecha de nacimiento",
      "Birth_Date_Day": "Fecha de nacimiento",
      "Nationality": "Nacionalidad",
      "isHavePass": "Por favor, seleccione",
      "NAT_ID": "Número de Pasaporte",
      "Phone": "Teléfono",
      "Doc_Type": "Por favor, seleccione",
      "Doc_No": "Por favor, introduzca el nº del documento de identidad",
      "Addr_Country": "Por favor, seleccione",
      "Bank_Card_No": "Número de banco",
      "Bank": "Por favor, seleccione",
      "OtherBank": "Otros bancos",
      "Beneficiary_Name": "Nombre del beneficiario",
      "Branch_Name": "Nombre de la sucursal",
      "Bank_Addr": "Dirección de sucursal",
      "Branch_Province": "Provincia de la sucursal",
      "Branch_City": "Ciudad de la sucursal",
      "FD_Emp_Status": "Por favor, seleccione",
      "FD_Position": "Cargo Profesional",
      "FD_Employer": "Nombre de la compañía",
      "FD_Biz_Nature": "Por favor, introduzca los atributos del negocio",
      "FD_FCA_AUTH": "Por favor, seleccione",
      "FD_Annual_Income": "Por favor, seleccione",
      "FD_Liquid_Net_Worth": "Por favor, seleccione",
      "FD_Portfolio_Value": "Por favor, seleccione",
      "FD_Funds_Source": "Por favor, seleccione",
      "FD_Funds_Other": "Por favor, seleccione",
      "E_Forex_Exp": "Por favor, seleccione",
      "E_Forex_Trade_No": "Por favor, seleccione",
      "E_Derivative_Exp": "Por favor, seleccione",
      "E_Derivative_Trade_No": "Por favor, seleccione",
      "E_Equity_Exp": "Por favor, seleccione",
      "E_Equity_Trade_No": "Por favor, seleccione",
      "K_A": "Por favor, seleccione",
      "K_A_Detail": "Detalles",
      "K_B": "Por favor, seleccione",
      "K_B_Detail": "Detalles",
      "K_C": "Por favor, seleccione",
      "K_C_Detail": "Detalles",
      "K_D": "Por favor, seleccione",
      "K_E": "Por favor, seleccione",
      "K_F": "Por favor, seleccione",
      "K_G": "Por favor, seleccione",
      "K_H": "Por favor, seleccione",
      "A1": "Por favor, seleccione",
      "A2": "Por favor, seleccione",
      "A3": "Por favor, seleccione",
      "A4": "Por favor, seleccione",
      "checkList": "Por favor, seleccione",
      "Emp_Status": "Por favor, seleccione",
      "Freelance_OwnACompany": "Por favor, seleccione",
      "Industry_Sector": "Por favor, seleccione",
      "Position": "Por favor, seleccione",
      "Employer": "Nombre de la compañía",
      "Biz_Nature": "Por favor, introduzca los atributos del negocio",
      "Annual_Income": "Por favor, seleccione",
      "Total_Saving_Investments": "Por favor, seleccione",
      "Funds_Source": "Por favor, seleccione",
      "Intend_Deposit": "Por favor, seleccione",
      "Other_Industry_Sector": "Otra industria / sector",
      "Other_Position": "Otro Cargo Profesional",
      "Other_Biz_Nature": "Otra naturaleza de negocios",
      "Other_Funds_Source": "Otras fuentes de ingresos",
      "Futures_Options": "Por favor, seleccione",
      "CFDs_Spread_Bets": "Por favor, seleccione",
      "Derivative_Trade_over2": "Por favor, seleccione",
      "Derivative_Trade_over40": "Por favor, seleccione",
      "DT_Work_Experience": "Por favor, seleccione",
      "DT_Qualification": "Por favor, seleccione",
      "K_Sell_Position": "Por favor, seleccione",
      "Closing_Order": "Por favor, seleccione",
      "K_Profit_Change": "Por favor, seleccione",
      "K_Margin": "Por favor, seleccione",
      "IBAN_Code":"Por favor ingrese el código IBAN",
      "Hear_ATFX":"Por favor, seleccione",
      "OtherHearATFX":"Por favor ingrese",
      "Rec_Type":"Por favor, seleccione",
      "Parent_IB_Code":"Código del remitente",
      "Afford_To_Lose":"Por favor, seleccione",
      "Open_Trading_Account":"Por favor, seleccione",
      "Annual_Income_Total":"Por favor, introduzca",
      "Saving_Investments_Money":"Por favor, introduzca",
      "IS_Politically_Person":"Por favor, seleccione",
      "isDualCitizenship":"Por favor, seleccione",
    }
  },
  "errors": {
    "fieldIsRequired": "Dirección de correo electrónico",
    "invalidFormat": "¡Formato no válido!",
    "numberTooSmall": "¡El número es demasiado pequeño! Mínimo: {0}",
    "numberTooBig": "¡El número es demasiado grande! Máximo: {0}",
    "invalidNumber": "¡Número no válido!",
    "textTooSmall": "¡La longitud del texto es demasiado pequeña! Actual: {0}, Mínimo: {1}",
    "textTooBig": "¡La longitud del texto es demasiado grande! Actual: {0}, Máximo: {1}",
    "thisNotText": "¡Esto no es un texto!",
    "thisNotArray": "¡Esto no es una serie!",
    "selectMinItems": "¡Seleccionar un mínimo de {0}artículos!",
    "selectMaxItems": "¡Seleccionar un máximo de {0} artículos!",
    "invalidDate": "¡Fecha no válida!",
    "dateIsEarly": "¡La fecha es demasiado prematura! Actual: {0}, Mínimo: {1}",
    "dateIsLate": "¡La fecha es demasiado tarde! Actual: {0}, Máximo: {1}",
    "invalidEmail": "¡La dirección de correo electrónico no está disponible!",
    "invalidURL": "¡URL no válido!",
    "invalidCard": "¡Formato de tarjeta no válido!",
    "invalidCardNumber": "¡Número de tarjeta no válido!",
    "invalidTextContainNumber": "¡Texto no válido! No puede contener números o caracteres especiales",
    "invalidTextContainSpec": "Texto no válido! No puede contener caracteres especiales",
    "incorrectComfirm": "Las dos entradas son inconsistentes",
    "invalidBirthDate": "Aceptación de solicitudes solo en edades de 18-69 años",
    "invalidParentClnID": "¡Por favor, introduzca un número menor a 12 dígitos!",
    "sizeLimit": "¡La imagen del documento de identidad (parte frontal) no puede exceder los 2MB!",
    "docImgBackSizeLimit": "¡La imagen del documento de identidad (parte trasera) no puede exceder los 2MB!",
    "imgSizeLimit": "La imagen de la prueba de residencia no puede exceder los 2MB.",
    "bankCardNoTopTwo": "Los dos primeros dígitos de la tarjeta bancaria no coinciden",
    "bankCardNoLnegth": "Por favor, introduzca un número de 16-19",
    "dayErrors1": "No hay día porque el año es un año bisiesto",
    "dayErrors2": "su año por año, el día no existe",
    "dayErrors3": "El día no existe este mes",
    "emailError": "La dirección de correo electrónico no está disponible",
    "DocTypeNoError": "El nº del documento de identidad no es legal",
    "DocFrontImg": "Por favor, cargue la imagen de su documento de identidad (parte frontal)",
    "DocBackImg": "Por favor, cargue la imagen de su documento de identidad (parte trasera)",
    "ProofofAddress": "Por favor, cargue la prueba de residencia",
    "Doc_No": "Por favor, introduzca el nº del documento de identidad",
    "Phone": "Teléfono",
    "Bank_Card_No": "Número de banco",
    "Birth_Date_Second": "Fecha de nacimiento",
    "phoneError": "Formato del teléfono incorrecto",
    "bankNumError": "El formato del número de banco es incorrecto",
    "numType": "por favor, introduzca un número",
    "bankCodeError":"El formato de codificación IBAN es incorrecto"
  },
  "messages": {
    "fieldsWillBeReset": "Todas las entradas serán restablecidas, por favor, confírmelo",
    "completeTip1": "Por favor, consulte su correo electrónico, gracias.",
    "completeTip2": "¡Completado! Gracias",
    "noCompleteTip": "Lo sentimos, pero su información de entrada es incorrecta y la operación anterior ha fallado",
    "emailAndDocInvalid": "La dirección de correo electrónico ya ha sido utilizada",
    "phoneAndDocInvalid": "El número de teléfono ya se ha utilizado",
    "IBCodeInvalid": "Código del remitente incorrecto",
    "invalidBankCardNo": "El número de la tarjeta bancaria no es correcto. Por favor, revíselo antes de enviarlo",
    "beneficiaryName": "Por favor, utilice el mismo nombre de la cuenta en su banco, no se permiten operaciones con terceros",
    "employerName": "No nos pondremos en contacto con su jefe",
    "errors": "Errores de red",
    "unSelect": "Por favor, seleccione",
    "selectEmpStatusTip":"Su estado de empleo muestra que es/está Retirado/ Estudiante/ Desempleado, El comercio de divisas (FOREX) y contratos por diferencia (CFDS) es altamente especulativo, el cual lleva un alto nivel de riesgo, para proteger sus intereses inmediatos, revisaremos que los productos que le ofrecemos son adecuados para usted basados en los documentos que nos proporcione confirmando el saldo de sus ahorros/ herencias mencionadas en su solicitud."
  },
  "ModalMsg": {
    "showModal": {
      "content": "Based on the information you provided on your AT Global Markets Limited (UK) Limited client account application, it is necessary for us to inform you that trading in CFDs and leveraged forex may not be appropriate for you. Leveraged trading carries a high degree of risk to your capital. The Company provides an execution-‐‐only service to its clients and you will need to rely upon your own skill and judgement when trading these markets. <br/><br/><b>Please note: AT Global Markets (UK) Limited oﬀers demo accounts where you can practice trading against realistic market prices and the Company would encourage you to try this before trading with real money.</b><br/><br/>If you still wish to open a client account with AT Global Markets (UK) Limited, please conﬁrm this by accepting the statement below.",
      "checkboxTxt":"Entiendo que operar con CFDs y operaciones apalancadas con FOREX  acarrea un alto riesgo en mi capital. Soy capaz de soportar este riesgo y deseo continuar con mi aplicación de apertura de cuenta.",
      "errorsTxt": "Por favor, seleccione",
      "btn": "Confirmar"
    },
    "showAlert": {
      "title": "consejo:",
      "submitBtnTxt": "confirmar",
      "cancleBtnTxt": "cancelar",
      "confirmBtnTxt": "confirmar"
    }
  },
  "ratesModalMsg": {
    "p3_1": "ADVERTENCIA - CAMBIOS DE LA TASA DE MARGEN PARA TODOS LOS COMERCIANTES MINORISTAS",
    "p3_2": "Querido solicitante,",
    "p3_2_1": "",
    "p3_3": "Tenga en cuenta que, debido a los cambios de la Autoridad Europea de Valores y Mercados (ESMA) para los comerciantes minoristas, todos los nuevos clientes de ATFX a partir del 2 de julio utilizarán las nuevas tasas de margen.",
    "p3_4": "Los cambios incluyen un límite en la cantidad de apalancamiento que se puede ofrecer a los comerciantes minoristas.",
    "p4_1": "FX principal: pares de divisas que contienen dos de los siguientes: USD, EUR, JPY, GBP, CAD, CHF - 3,33% (Apalancamiento 30: 1)",
    "p4_2": "FX menor: todos los demás pares de divisas: 5% (apalancamiento 20: 1)",
    "p4_3": "Índices principales: UK100, FRA40, ESP35, US30, SPX500, NAS100, JP225, AUS200 5% (Apalancamiento 20: 1)",
    "p4_4": "Oro: 5% (Apalancamiento 20: 1)",
    "p4_5": "Materias primas: 10% (apalancamiento 10: 1)",
    "p5_1": "Protección de balance negativo",
    "p5_2": "La ESMA ha introducido una nueva regla para garantizar que todos los comerciantes minoristas nunca puedan perder más que el dinero disponible en sus cuentas. Si su saldo es negativo, ATFX estará obligado a volver a poner su saldo a cero, sin costo para usted, el cliente.",
    "p5_3": "Regla de cierre del margen del 50%.",
    "p5_4": "ATFX ya ofrece la regla de cierre del margen del 50% a todos los clientes.",
    "p5_5": "Si desea finalizar su solicitud y abrir una cuenta minorista ATFX, marque la casilla a continuación.",
    "p5_6": "Reconozco y acepto los nuevos términos para clientes minoristas",
    "p6_2": "Por favor de acuerdo ",
    "btnText": "ENVIAR"
  },
  "verifyMsg": {
    "phone_exist": "Este número de teléfono ya se ha utilizado, utilice un número de teléfono alternativo.",
    "email_exist": "Esta dirección de correo electrónico ya se ha utilizado, utilice una dirección de correo electrónico alternativa.",
    "phoneAndemail_exist": "El número de teléfono y la dirección de correo electrónico ya se han utilizado, utilice el número de teléfono alternativo y la dirección de correo electrónico.",
  }
}



// WEBPACK FOOTER //
// ./src/lang/es.js